import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["btn-block", _ctx.blockClass])
  }, [
    _createVNode(_component_ButtonComponent, {
      class: _normalizeClass(_ctx.buttonClass),
      disabled: _ctx.isDisabled,
      onOnClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["class", "disabled", "onOnClick"])
  ], 2))
}